/*
call function or emitting "ok" event with element node, if empty when ctrl+enter is pressed

Usage:

ES6:
import vo from "vue-ok.js"
Vue.use( vo )

ES5:
var vo = require("vue-ok.js")
Vue.use( vo )

template:
<div
  v-ok="myfunc" //!!! without ()
  v-ok
  v-ok:enter
  v-ok:ctrlEnter
>
...
</div>
*/
let vueOk = {};

vueOk.install = function ( Vue ) {
	let handle;
	
	Vue.directive(
		"ok",
		{
			bind( el, binding, vnode ) {
				let type = binding.arg ? binding.arg.toLowerCase() : "";
				if ( type !== "enter" && type !== "ctrlenter" && type !== "shiftenter" ) type = "ctrlenter";

				handle = e => {
					if ( ( e.target === el || el.contains( e.target ) ) && e.key === "Enter" ) {
						if (
							( type == "enter" && ( !e.shiftKey && !e.ctrlKey ) ) ||
							( type == "ctrlenter" && e.ctrlKey ) ||
							( type == "shiftenter" && e.shiftKey )
						) {
							if ( binding.value || binding.expression ) {
								if( typeof binding.value === "function" ) binding.value.bind( vnode.context )( "ok", e );
								else new Function( binding.expression.replace( /^(")(.*?)\1$/, "$2" ) ).bind( vnode.context )( el, e )
							}
							else vnode.context.$emit( "ok", el );

							e.preventDefault();
							return false;
						}
					}
				};
				
				document.addEventListener( "keydown", handle );
			},
			
			unbind() {
				document.removeEventListener( "keydown", handle );
			}
		}
	);
};

if ( typeof window !== "undefined" && window.Vue ) {
	window.Vue.use( vueOk )
}

export default vueOk;
